<template>
  <div class="modal fade" id="exportStatusModal" tabindex="-1" role="dialog" aria-labelledby="exportStatusModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exportStatusModalLabel">
            <i class="fa fa-download"></i>
            Exportar Contratos
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-info">
            <i class="fa fa-info-circle"></i>
            <strong> Importante:</strong> Para melhor performance, selecione um status específico para exportar.
            A exportação de todos os contratos pode demorar muito tempo.
          </div>

          <div class="form-group">
            <label for="statusSelect">Selecione o status dos contratos para exportar:</label>
            <select id="statusSelect" v-model="selectedStatus" class="form-control" required>
              <option value="">-- Selecione um status --</option>
              <option value="proposal_sent">Proposta Enviada</option>
              <option value="payment_completed">Pagamento Concluído</option>
              <option value="account_created">Conta Criada</option>
              <option value="proposal_cancelled">Proposta Cancelada</option>
            </select>
          </div>

          <div class="form-group">
            <div class="alert alert-warning">
              <i class="fa fa-exclamation-triangle"></i>
              <strong>Atenção:</strong> A seleção de status é obrigatória para garantir melhor performance na
              exportação.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            <i class="fa fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="confirmExportAction" :disabled="!selectedStatus">
            <i class="fa fa-download"></i>
            Exportar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportStatusModal',
  data() {
    return {
      selectedStatus: ''
    }
  },
  methods: {
    confirmExportAction() {
      if (this.selectedStatus) {
        this.$emit('export-confirmed', this.selectedStatus, true);
        this.resetModal();
        $('#exportStatusModal').modal('hide');
      }
    },
    resetModal() {
      this.selectedStatus = '';
    }
  },
  mounted() {
    // Reset modal quando é fechado
    $('#exportStatusModal').on('hidden.bs.modal', () => {
      this.resetModal();
    });
  }
}
</script>

<style scoped>
.alert {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-check {
  margin-top: 10px;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  color: #495057;
  font-weight: 600;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  opacity: 0.65;
}
</style>